
const urlPropertyEntities = process.env.REACT_APP_MICRO_GLOBAL_ENTITY;

export const getEntitiesRewards = async ({ token, values }) => {
    const requestOptions = {
        method: 'GET',
        headers: {
            'Content-type': 'application/json',
            'Authorization': `Bearer ${token}`,
            'x-api-key': process.env.REACT_APP_MICRO_GLOBAL_ENTITY_XAPIKEY
        }
    };
    const urlRequest = `${urlPropertyEntities}get_entities_rewards?country=MX&${values}`;
    const res = await fetch(urlRequest, requestOptions);
    return res.json();
};

export const postEntitiesRewards = async (data: any, token: string) => {
    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': '*',
            'Authorization': `Bearer ${token}`,
            'x-api-key': process.env.REACT_APP_MICRO_GLOBAL_ENTITY_XAPIKEY
        },
        body: JSON.stringify(data),
    };
    const urlRequest = `${urlPropertyEntities}post_entities_rewards`;
    const res = await fetch(urlRequest, requestOptions);
    return res.json();
};